/*
 * @Author: 朱亚
 * @Date: 2020-10-10 10:19:09
 * @说明：图片验证码接口地址
 */
// 获取图片验证码url,token
export const index = '/verify-image/index'
// 验证图片验证码
export const check = '/verify-image/check'



// WEBPACK FOOTER //
// ./src/api/url/verifyImage.js